import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import redTik from "assets/img/redTik.svg";
import {styled} from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import styles from 'assets/jss/Scan/scanStyle';
import {supportNfLevels} from 'helpers/scanLevels';
const useStyles = makeStyles(styles)

const CustomizedDialog = styled(Dialog)`
  & .MuiDialog-paper {
    width: 100%;
    height: 260px;
    max-width: 100%;
    background: #f5f5f5;
    border: 1px solid #ffffff;
    box-shadow: 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #ffffff;
    border-radius: 16px;
    padding: 26px 24px 34px;
  }
  & .MuiBackdrop-root {
    background-color: rgba(216, 216, 216, 0.3);
    backdrop-filter: blur(6.7957px);
  }
`;

const ScanModalNfcSupport = (props) => {
    const {checkState,checkOpen,setCheckOpen,handleCorrect}=props
    const classes = useStyles()
    const goToSetting = () => {
        window.ReactNativeWebView.postMessage('openNFC');
        checkHandleClose();

    };

    const checkHandleClose = () => {
        setCheckOpen(false);
    };
    const checkOnCloseClick = (event, reason) => {
        if (reason && reason === 'backdropClick') return;
        checkHandleClose();
    };
  return(
      <CustomizedDialog
      open={checkOpen}
      onClose={checkOnCloseClick}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
  >
      {
      //     checkState === supportNfLevels.NFC_NOT_SUPPORTED ? (
      //     <div>
      //         <DialogTitle className={classes.dialogText} id='alert-dialog-title'>
      //             <IconButton
      //                 aria-label='close'
      //                 onClick={checkHandleClose}
      //                 sx={{
      //                     position: 'absolute',
      //                     right: 8,
      //                     top: 8,
      //                     color: (theme) => theme.palette.grey[500],
      //                 }}
      //             >
      //                 <CloseIcon/>
      //             </IconButton>
      //             <img src={redTik}/>
      //         </DialogTitle>
      //         <DialogContent>
      //             <DialogContentText
      //                 className={classes.dialogLongText}
      //                 id='alert-dialog-description'
      //             >
      //                 این مدل گوشی موبایل از
      //                 تکنولوژی NFC پشتیبانی نمی کند.
      //
      //                 <br/>
      //                 <br/>
      //                 شما باید برای اسکن کردن دستگاه،
      //                 از گوشی موبایل دارای NFC استفاده کنید.
      //
      //             </DialogContentText>
      //         </DialogContent>
      //         <DialogActions className={classes.buttonContainer}>
      //             <Button className={classes.dialogButtonSupportNfc} onClick={checkHandleClose}>
      //                 بازگشت
      //             </Button>
      //         </DialogActions>
      //     </div>
      // ) :
          checkState === supportNfLevels.NFC_NOT_ENABLED && (
          <div>
              <DialogTitle className={classes.dialogText} id='alert-dialog-title'>
                  <IconButton
                      aria-label='close'
                      onClick={checkHandleClose}
                      sx={{
                          position: 'absolute',
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                      }}
                  >
                      <CloseIcon/>
                  </IconButton>
                  <img src={redTik}/>
              </DialogTitle>
              <DialogContent>
                  <DialogContentText
                      className={classes.dialogPurpleText}
                      id='alert-dialog-description'
                  >
                                <span>
                                    NFC موبایل شما
                                    <span style={{color: '#4e4e4e'}}> خاموش </span>
                                    است،
                                    <br/>
                                    برای روشن کردن آن، به بخش
                                    تنظیمات موبایل خود بروید.
                                </span>
                  </DialogContentText>
              </DialogContent>
              <DialogActions className={classes.buttonContainer}>
                  <Button className={classes.dialogButtonSupportNfc} onClick={goToSetting}>
                      ورود به تنظیمات موبایل
                  </Button>
              </DialogActions>
          </div>
      )}
  </CustomizedDialog>
  )
}
export default ScanModalNfcSupport